import { type BusinessConnectionType, businessConnectionType } from '@libs/enums';
import type { Locale } from '@ps-smart-cp/ppfw-client';

interface BusinessConnectionClassProps {
  businessConnectionClass: Set<BusinessConnectionType>;
  benchmark: BusinessConnectionType;
  locale: Locale;
}

function BusinessConnectionClassCell({
  businessConnectionClass,
  benchmark,
  locale,
}: BusinessConnectionClassProps) {
  return businessConnectionClass.has(benchmark) ? businessConnectionType.toDisplay(benchmark, locale) : '';
}

export { BusinessConnectionClassCell };
